angular.module('mercury.dialogs.welcome', []);
